import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';

export interface ISelectDropdownItem {
  id: number | undefined;
  key?: string | number;
  node: React.ReactElement<any>;
}

export interface ISelectDropdownProps {
  title: number | string;
  header?: React.ReactNode;
  items: ISelectDropdownItem[];
  onItemClick(id: number | undefined): void;
  onClose(): void;
}

export function SelectDropdown({
  title,
  items,
  header,
  onClose,
  onItemClick,
}: ISelectDropdownProps): React.JSX.Element {
  const onContentItemClick = React.useCallback((id: number | undefined) => () => onItemClick(id), [onItemClick]);

  const content = items.map(({ id, key, node }) => (
    <div key={key || id} onClick={onContentItemClick(id)}>
      {node}
    </div>
  ));

  return (
    <ModalWindow
      title={title}
      header={header}
      open
      outside
      size="M"
      content={content}
      onClose={onClose}
      fixed={false}
      width="100%"
      maxWidth={600}
    />
  );
}
